/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { assetUrl, brandName } from "../../portalSettings";
import LanguageSwitcher from "./LanguageSwitcher";

/** הלוגו שהיישום מגיע איתו. מוצג לריסיילר שלא הועלה לו דבר. */
const DEFAULT_LOGO = "/images/header-logo.png";

/**
 * **קביעת השפה ירדה מכאן.** היא נעשית ב-`src/i18n/config.js`, לפני שנוצר המסך הראשון.
 *
 * מה שהיה כאן היה `useEffect` עם השהיה שתיקן את השפה **אחרי** שהמסך צויר, ושני דברים
 * נשברו בגללו: הבהוב של מסך בעברית לפני שהוא מתהפך לאנגלית, ומסך שאינו מצויר בתוך
 * `Frame` - מסך ההתחברות הסלולרי - שלא קיבל את התיקון כלל ונשאר עברי לתמיד.
 */
const Header = () => {
  const reseller = useSelector((state) => state.reseller.value);

  /**
   * הלוגו: מה שהריסיילר העלה, אחרת התיקייה הידנית, אחרת של היישום.
   * שלוש השכבות ב-`assetUrl`; כאן רק השכבה האחרונה, שהיא של הקוד ולא של הנתונים.
   */
  const logo = assetUrl(reseller, "logo", "logo_new.png") || DEFAULT_LOGO;

  return (
    <div className="header">
      {/*
          הסמל הוא הדרך חזרה להתחלה - קישור, ולא תמונה.

          `Link` ולא `<a href="/">`: זו ניווט בתוך היישום, וטעינה מחדש של העמוד הייתה
          מאבדת את מצב המסך ומבקשת מהשרת את כל הנכסים שוב. לריסיילר סלולרי `/` מפנה
          למסך ההתחברות שלו (ראה `RedirectByReseller`), כלומר "ההתחלה" בשתי הערכות.
      */}
      <Link to="/" className="header-logo-link" aria-label={brandName(reseller) || ""}>
        <img src={logo} className="header-logo" alt={brandName(reseller) || ""} />
      </Link>
      {/* הבורר עצמו, ואת שאלת ההצגה שלו הוא שואל - ראה `LanguageSwitcher`. */}
      <LanguageSwitcher className="header-icons" />
    </div>
  );
};

export default Header;
